import { QarepaEnumInformation } from '@qarepa/common';

export enum ProfileViewEnum {
  INFO = 'INFO',
  EDIT = 'EDIT',
  PASSWORD = 'PASSWORD',
}

export const ProileViewArray = [
  ProfileViewEnum.INFO,
  ProfileViewEnum.EDIT,
  ProfileViewEnum.PASSWORD,
];

export const ProfileViewInfo: QarepaEnumInformation<ProfileViewEnum> = {
  [ProfileViewEnum.INFO]: {
    name: $localize`Información`,
  },
  [ProfileViewEnum.EDIT]: {
    name: $localize`Edición`,
  },
  [ProfileViewEnum.PASSWORD]: {
    name: $localize`Restablecer contraseña`,
  },
};
